import React, { useState, useEffect, useRef } from 'react';
import scrollImage from '../../Assets/scroll.png';

const HomeThree = () => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const isMobile = windowWidth <= 767;
    const isTablet = windowWidth > 767 && windowWidth <= 1023;
    
    // Ref for the component to check if it's mounted
    const componentMounted = useRef(true);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        
        return () => {
            componentMounted.current = false;
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className={`flex justify-center ${isMobile ? 'mt-12' : isTablet ? 'mt-16' : 'mt-20'}`}>
            <div className={`scrollSection relative ${isMobile ? 'flex items-center' : ''}`}>
                <div className={`scrollImage ${isMobile ? 'static flex items-center mr-3' : isTablet ? 'left-[-40px]' : ''}`}>
                    <img 
                        src={scrollImage} 
                        alt="Scroll" 
                        className={isMobile ? 'w-[60px]' : isTablet ? 'w-[90px]' : ''}
                    />
                </div>
                <div className={`scrollText ${isMobile ? 'text-lg static' : isTablet ? 'text-xl' : ''}`}>
                    Scroll down here
                </div>
            </div>
        </div>
    );
};

export default HomeThree;
